import { debug } from 'glonass/core/global'
import shop from 'glonass/shop/site/store'

/* eslint-disable no-undef */
export default new Vuex.Store({
  strict: debug,

  modules: {
    shop
  }
})



// WEBPACK FOOTER //
// ./resources/assets/site/store/index.js